import { percentage } from "./percentage";
import { currency } from "./currency";

export { currency } from "./currency";
export { percentage } from "./percentage";

export const formatters = {
  currency,
  percentage,
};

export type ValueFormatterKeys = keyof typeof formatters;
